/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProgramOption,
    ProgramOptionFromJSON,
    ProgramOptionFromJSONTyped,
    ProgramOptionToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProgramGroupOption
 */
export interface ProgramGroupOption {
    /**
     * 
     * @type {number}
     * @memberof ProgramGroupOption
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProgramGroupOption
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramGroupOption
     */
    nameJa: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramGroupOption
     */
    descriptionForApplicant?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramGroupOption
     */
    descriptionForApplicantEn?: string;
    /**
     * 
     * @type {Array<ProgramOption>}
     * @memberof ProgramGroupOption
     */
    options: Array<ProgramOption>;
}

export function ProgramGroupOptionFromJSON(json: any): ProgramGroupOption {
    return ProgramGroupOptionFromJSONTyped(json, false);
}

export function ProgramGroupOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramGroupOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'nameJa': json['nameJa'],
        'descriptionForApplicant': !exists(json, 'descriptionForApplicant') ? undefined : json['descriptionForApplicant'],
        'descriptionForApplicantEn': !exists(json, 'descriptionForApplicantEn') ? undefined : json['descriptionForApplicantEn'],
        'options': ((json['options'] as Array<any>).map(ProgramOptionFromJSON)),
    };
}

export function ProgramGroupOptionToJSON(value?: ProgramGroupOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'nameJa': value.nameJa,
        'descriptionForApplicant': value.descriptionForApplicant,
        'descriptionForApplicantEn': value.descriptionForApplicantEn,
        'options': ((value.options as Array<any>).map(ProgramOptionToJSON)),
    };
}


